import React, { useEffect } from 'react';
import CommonUtil from '../../utils/CommonUtil';

const Captcha = () => {
    let captcha

    const getInstance = (instance) => {
        captcha = instance
    }

    const captchaVerifyCallback = async (captchaVerifyParam) => {
        console.log('人机验证结果: ', captchaVerifyParam)
        let result = {}
        try {
            result = await sendMessageToRN('getVerifyResult', captchaVerifyParam)
            console.log('验证结果: ', result)
        } catch (error) {
            console.error('发生错误: ', error)
            result = {
                captchaResult: false,
                bizResult: false
            }
        }

        const verifyResult = {
            captchaResult: result.captchaResult,
            bizResult: result.bizResult
        }
        return verifyResult
    }

    const sendMessageToRN = (action, data) => {
        return new Promise((resolve, reject) => {
            const callbackName = 'cb_' + Math.random().toString(36).substring(2)

            window[callbackName] = (response) => {
                console.log('RN 验证结果: ', response)
                resolve(response)
                delete window[callbackName]
            }

            if (CommonUtil.isInApp(navigator.userAgent)) {
                const message = {
                    data,
                    action,
                    callback: callbackName
                }
                window.ReactNativeWebView.postMessage(JSON.stringify(message))
            }
        })
    }

    const onBizResultCallback = (bizResult) => {
        console.log('业务结果回调: ', bizResult)
        if (bizResult === true) {
            window.ReactNativeWebView.postMessage('closeWebView')
        }
    }

    useEffect(() => {
        window.initAliyunCaptcha({
            SceneId: '1gjhr5oz', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
            prefix: 'rat1pm', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
            mode: 'embed', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
            element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
            button: '#captcha-button', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
            immediate: true,
            captchaVerifyCallback: captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
            onBizResultCallback: onBizResultCallback, // 业务请求结果回调函数，无需修改
            getInstance: getInstance, // 绑定验证码实例函数，无需修改
            slideStyle: {
                width: 360,
                height: 40,
            }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
            language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
        });

        window.addEventListener('message', (event) => {
            console.log('event from webview: ', event.data)
            if (event.data && event.data.captchaVerifyResult) {
                alert('ddd')
            }
        })
        return () => {
            // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
            document.getElementById('aliyunCaptcha-mask')?.remove();
            document.getElementById('aliyunCaptcha-window-popup')?.remove();
        }
    }, [])

    return (
        <div className="captcha-a">
            <div id="captcha-element"></div>
            <div id="captcha-button"></div>
        </div>
    )
}

export default Captcha